import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import LordIcon from 'components/global/LordIcon';
import Modal from 'components/global/Modal';
import * as S from 'components/global/styled/ConfirmationModal.styled';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useLocale from 'hooks/useLocale';

import { USERS } from 'services/consts';

import { THEME } from 'utils/Theme';

const SupportRequestAccessForm = NiceModal.create(() => {
	const axios = useAxiosPrivate();
	const modal = useModal();
	const { getLocaleDateWithTime } = useLocale();
	const darkMode = useSelector((state) => state.layout.darkMode);
	const twoDaysLater = new Date();
	const { t } = useTranslation();
	twoDaysLater.setDate(twoDaysLater.getDate() + 2);

	const approve = () => {
		axios.post(USERS.APPROVE_SUPPORT_ACCESS, { supportAccessLink: window.location.href });
	};

	return (
		<Modal maxWidth="x-small" fullwidth closeButton={false} className="modal-confirmation">
			<S.Container>
				<S.IconContainer>
					<LordIcon
						primaryColor={darkMode ? THEME.WHITE : THEME.BLACK}
						secondaryColor={darkMode ? THEME.DARK.PRIMARY_COLOR : THEME.LIGHT.PRIMARY_COLOR}
						width={120}
						height={120}
						src="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/customer-support.json.gz"
					/>
				</S.IconContainer>
				<S.HeadText>{t('supportAccessApproveTitle')}</S.HeadText>
				<S.BodyText>
					<Trans
						i18nKey="supportAccessApproveSubTitle"
						values={{ date: getLocaleDateWithTime(twoDaysLater) }}
					/>
				</S.BodyText>
				<S.BlockDiv>
					<S.ButtonContainer>
						<Button
							onClick={() => {
								modal.remove();
							}}
							label="Deny"
							variant="outline"
							style={{ minWidth: '70px' }}
						/>
					</S.ButtonContainer>
					<S.ButtonContainer>
						<Button
							onClick={() => {
								modal.remove();
								approve();
							}}
							variant="blue"
							style={{ minWidth: '70px' }}
							label="Approve"
						/>
					</S.ButtonContainer>
				</S.BlockDiv>
			</S.Container>
		</Modal>
	);
});

export default SupportRequestAccessForm;
